import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useTask } from "@/composables/tasks/useTask";
import { useRoute } from "vue-router";
import { normalizeRouteParam } from "@/utils/v2/routes";
import { TasksService } from "@/services/v2/tasks";
import { useTasksStore } from "@/stores/v2";
import { onMounted } from "vue";

import EnvAttrsModifier from "@/components/v2/Tasks/EnvAttrsModifier/index.vue";
import LayoutMain from "@/components/v2/Layouts/LayoutMain.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'EnvironmentalModifierTaskPage',
  setup(__props) {

const { startObserver } = useTask();
const route = useRoute();
const taskKey = normalizeRouteParam(route.params.key)

const init = async () => {
  try {
    const task = await TasksService.startTask(taskKey);
    if (!task) {
      return
    }
    await useTasksStore().setActiveTask(task);

    startObserver();
  } catch (err) {
    alert("Error during initialization:" + err);
  }
};

onMounted(init);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutMain, null, {
    mainArea: _withCtx(() => [
      _createVNode(EnvAttrsModifier)
    ]),
    _: 1
  }))
}
}

})